import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../utils/createNotification';
import { Profile } from '../models/profile';
import { MarketplaceSellerProfile } from '../models/marketplace-seller-profile';
import { keepServerChangesToSyncedLocationFields } from '../keep-server-changes-to-synced-location-fields';

const resolveProfileToSave = async (
    profile: Profile | MarketplaceSellerProfile,
    loadedProfile: Profile,
    axios: any
): Promise<Profile | MarketplaceSellerProfile> => {
    if (
        !loadedProfile ||
        loadedProfile.id !== profile.id ||
        !(profile as MarketplaceSellerProfile).practiceProfiles
    ) {
        return profile;
    }

    try {
        const response = await axios.get(`api/Profiles/${profile.id}`);

        return keepServerChangesToSyncedLocationFields(
            profile as MarketplaceSellerProfile,
            loadedProfile as MarketplaceSellerProfile,
            response.data
        );
    } catch {
        return profile;
    }
};

export const UpdateProfile = createAsyncThunk(
    'profilesData/updateProfile',
    async (profile: Profile | MarketplaceSellerProfile, { getState }: any) => {
        const axios = getState().core.axios;
        const loadedProfile = getState().profilesData.selectedPofile;
        try {
            const profileToSave = await resolveProfileToSave(
                profile,
                loadedProfile,
                axios
            );
            const response = await axios.put(
                `api/Profiles/${profile.id}`,
                profileToSave
            );

            if (response.status === 200) {
                return profileToSave;
            }

            throw new Error('Failed to update profile');
        } catch (error) {
            createNotification(
                'Something went wrong, could not update profile. Please try again.',
                'error'
            );
            throw error;
        }
    }
);
